import {Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {LdapUser} from "@Services/ldap/ldap/ldap-user.model";
import {SubSink} from "@Common/core/utils/subsink";
import {IndividuService} from "@Common/core/services";
import {
  GroupListsRequesters
} from "../../../gestion/reponses/reponse-fiche/request-opinion/group-list-requesters.model";
import {OpinionRequesterCopyRecipients} from "../../../gestion/reponses/reponse-fiche/request-opinion/opinion-requester.model";
import {SnackBarToastyService, typeToast} from "@Common/widgets/general/snack-bar";
import {FormListRequestersService} from "../../services/requesters-form/requesters-form.service";
import {FormListRequesters} from "../../services/requesters-form/requesters-form.model";

@Component({
  selector: 'app-ldap-lists-select',
  templateUrl: './ldap-lists-select.component.html',
  styleUrls: ['./ldap-lists-select.component.scss']
})
export class LdapListsSelectComponent implements OnInit, OnDestroy {
  @Input({ required: true }) formId: number;
  @Input() personsText = 'Liste des personnes qui seront en copie :';
  @Output() onPersonsUpdated = new EventEmitter<OpinionRequesterCopyRecipients[]>();

  private individuSvc = inject(IndividuService);
  private snackSvc = inject(SnackBarToastyService);
  private formListRequestersSvc = inject(FormListRequestersService);

  listGuests: OpinionRequesterCopyRecipients[] = [];
  urlIndividuGetOrCreate = '/demat/individu/';
  groupListsSelect: GroupListsRequesters[] = [];
  allReadyExist = '';
  subSink= new SubSink();

  ngOnInit(): void {
    this._fetchListOfRequestersForForm(this.formId);
  }
  onSelectIndividuLdap(ldapUser: LdapUser) {
    const uid = ldapUser.uid[0];
    this.subSink.sink = this.individuSvc
       .getOrCreate(uid, this.urlIndividuGetOrCreate)
       .subscribe(_ => this._addPersonChips(uid, ldapUser.cn[0], ldapUser.mail[0]));
  }
  onSelectListRequesters(user: OpinionRequesterCopyRecipients) {
    this._addPersonChips(user.uid, user.displayName, user.email)
  }
  deleteGuestChip(user: OpinionRequesterCopyRecipients) {
    const _idx = this.listGuests.findIndex(_guest => _guest.uid === user.uid);
    if (_idx > -1) {
      this.listGuests.splice(_idx, 1);
      this.onPersonsUpdated.emit(this.listGuests);
    }
  }
  toolTipSelectedPersons(person: OpinionRequesterCopyRecipients) {
    return `${person.displayName} ${person.email} ${person.informations ? ` - ${person.informations}` : ''}`;
  }
  private _fetchListOfRequestersForForm(id: number) {
    if (id) {
      const _extraParams = new Map<string, string>([['forms_demat', id.toString()]]);
      this.subSink.sink = this.formListRequestersSvc
        .listAllItems(_extraParams)
        .subscribe(_data => {
          if (_data.list.length > 0) {
            this._transformListRequestersForSelect(_data.list);
          }
        });
    }
  }
  private _addPersonChips(uid: string, displayName: string, email: string) {
    this.allReadyExist = '';
    if (! this.listGuests.find(_user => _user.uid === uid)) {
      this.listGuests.push(<OpinionRequesterCopyRecipients> {
        uid: uid,
        displayName: displayName,
        email: email
      });
      this.onPersonsUpdated.emit(this.listGuests);
    } else {
      this.allReadyExist = `La personne ${displayName} a déjà ajoutée dans la liste`;
      this.snackSvc.toasty('Mise en copie', this.allReadyExist, typeToast.warning, 4000);
    }
  }
  private _transformListRequestersForSelect(listRequesters: FormListRequesters[]) {
    this.groupListsSelect = listRequesters.map(_item => ({
      listName: _item.name,
      requesters: _item.requesters_obj.map(_requester => ({
        uid: _requester.user_obj.username,
        displayName: `${_requester.user_obj.first_name} ${_requester.user_obj.last_name}`,
        email: _requester.user_obj.email,
        informations: _requester.informations || ''
      }))
    } as GroupListsRequesters));
  }
  ngOnDestroy(): void {
   this.subSink.unsubscribe();
  }
}
